<template>
    <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: "chart",
        },
        width: {
            type: String,
            default: "100%",
        },
        eHeight: {
            type: String,
            default: "100%",
        },
        autoResize: {
            type: Boolean,
            default: true,
        },
        chartData: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            chart: null,
        };
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                // this.setOptions(val);
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart();
        });
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$el, "macarons");
            // this.setOptions(this.chartData || {});
        },
        setOptions(data) {
            console.log("工作信息统计",data);
            let _this = this;
            let setOptionStyle = {
                // title: {
                //   text: "同名数量统计",
                //   subtext: "纯属虚构",
                //   left: "center",
                // },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                    backgroundColor:'rgba(255,255,255,1)'
                },
                legend: {
                    type: "scroll",
                    orient: "vertical",
                    right: 10,
                    top: 20,
                    bottom: 20,
                    textStyle: {
                        color: _this.isbig ? "#AABEFF" : "#AABEFF",
                    }
                    // data: data.legendData,
                },
                series: [{
                    name: "类型",
                    type: "pie",
                    radius: "55%",
                    center: ["40%", "50%"],
                    // data: data.seriesData,
                    data: [
                        { value: 15, name: "关爱青少年" },
                        { value: 2, name: "禁毒进校园" },
                        { value: 2, name: "健康教育" },
                        { value: 2, name: "防艾宣传" },
                        { value: 2, name: "助残助盲" },
                        { value: 2, name: "健康进校园" },
                        { value: 2, name: "文明交通" },
                        { value: 2, name: "志愿服务" },
                        { value: 2, name: "法制进校园活动" },
                        { value: 2, name: "关爱留守困境儿童" },
                        { value: 2, name: "心理辅导" },
                        { value: 2, name: "心理援助" },
                        { value: 2, name: "社区矫正" },
                        { value: 2, name: "维权案件" },
                        { value: 2, name: "活动发布" },
                    ],
                    label:{
                        textBorderColor:'transparent',
                        textBorderWidth:0,
                        color: _this.isbig ? "#AABEFF" : "",
                    },
                    emphasis: {
                      // scale:false,
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        }
                    },
                }, ],
            }
            setOptionStyle.series[0].data=[]
            for(var key in data){
                let dataList={ value: 15, name: "关爱青少年" };
                dataList.name = data[key].name;
                dataList.value = data[key].value;
                setOptionStyle.series[0].data.push(dataList);
            }
            this.chart.setOption(setOptionStyle);
        },
    },
};

</script>
